export type TSources = 'default' | 'localhost';

export const getSource = (source: TSources, port?: number) => {
  if (source === 'default') return import.meta.env.VITE_AUTOMATIONS_BASE_URL;

  return `http://localhost:${port}/automations`;
};
